/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useState } from 'react';

import { SetUser } from 'blb-ui-types/login';

import { PhoneMFAForm } from './PhoneMFAForm';
import { EmailMFAForm } from './EmailMFAForm';

export namespace SetupMFAPage {
  export interface Props {
    setMe: SetUser;
  }
}

export const SetupMFAPage: React.FC<SetupMFAPage.Props> = ({ setMe }) => {
  const [useEmailMFA, setUseEmailMFA] = useState(false);

  return useEmailMFA ? (
    <EmailMFAForm setMe={setMe} setUseEmailMFA={setUseEmailMFA} />
  ) : (
    <PhoneMFAForm setMe={setMe} setUseEmailMFA={setUseEmailMFA} />
  );
};
